// extracted by mini-css-extract-plugin
module.exports = {"root":"Body_root__EdsD4"};